import type { SectionCollapseStates } from '@/components/InvoiceReportDetailDrawer/hooks/useSectionCollapseStates';
import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import { GetInvoiceReportSummaryResponse } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { LeftContent } from './LeftContent';
import { RightContent } from './RightContent';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type InvoiceReportDetailProps = {
  summaryData?: GetInvoiceReportSummaryResponse;
  isLoading: boolean;
  reportId: string;
  sectionStates?: SectionCollapseStates;
  onSectionToggle?: (sectionId: string, isOpen: boolean) => void;
};

const InnerDetail: FC<InvoiceReportDetailProps> = ({
  summaryData,
  isLoading,
  reportId,
  sectionStates,
  onSectionToggle,
}) => {
  return (
    <div className={cx('detail')}>
      <LeftContent
        data={summaryData}
        isLoading={isLoading}
        reportId={reportId}
        sectionStates={sectionStates}
        onSectionToggle={onSectionToggle}
      />
      <RightContent reportId={reportId} />
    </div>
  );
};

export const InvoiceReportDetail: FC<InvoiceReportDetailProps> = memo(
  (props) => {
    return (
      <SuspenseErrorBoundary>
        <InnerDetail {...props} />
      </SuspenseErrorBoundary>
    );
  }
);

InvoiceReportDetail.displayName = 'InvoiceReportDetail';
